module.exports = __webpack_public_path__ + "img/logo_nps_portal.42cc3f2f.png";